import { z } from "zod";

export const OAuthCallbackQuerySchema = z.object({
  code: z.string().min(1),
  state: z.string().min(1),
});

export type OAuthCallbackQuery = z.infer<typeof OAuthCallbackQuerySchema>;
